import { ERP } from '../_base/endpoint';
import axios from 'axios';


class condicionSunatService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/condicion-sunat`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new condicionSunatService();